/* Livre de naissance · script unique de la boutique, v2 (préfixe ln-).
   1. origine des visites (utm) · 2. cookies et pixel (rien avant l'accord) · 3. panier (compteur, garde du livre à 49 €)
   4. LA couverture (une seule fonction pour tout le site) · 5. l'atelier de création pas à pas → panier réel
   6. le mouvement : ouverture du livre, récit au défilement, feuilletage, voix, en-tête et menu. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var corps = document.body;
  var lire = function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } };
  var ecrire = function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var euros = function (centimes) { var n = centimes / 100; return (Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ',')) + ' €'; };
  var euros2 = function (centimes) { return (centimes / 100).toFixed(2).replace('.', ',') + ' €'; };
  var PRODUIT = corps.dataset.produit || 'livre-de-naissance';
  var SECOND = corps.dataset.second || 'livre-supplementaire';

  /* ================= 1. origine des visites ================= */
  (function () {
    var p = new URLSearchParams(location.search), o = {}, vu = false;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach(function (k) {
      if (p.get(k)) { o[k] = p.get(k).slice(0, 120); vu = true; }
    });
    if (vu) { o.arrivee = new Date().toISOString().slice(0, 16); ecrire('ln-origine', o); }
  })();
  function attributsOrigine() {
    var o = lire('ln-origine'); if (!o) return null;
    var a = {};
    Object.keys(o).forEach(function (k) { a[k] = o[k]; });
    return a;
  }

  /* ================= 2. cookies, consentement, pixel ================= */
  function confidentialite(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy) return cb(S.customerPrivacy);
    if (S && S.loadFeatures) S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err && window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
    });
  }
  var pixelCharge = false;
  function chargerPixel() {
    var id = corps.dataset.pixel;
    if (!id || pixelCharge) return;
    pixelCharge = true;
    /* code officiel de Meta, chargé seulement après « Accepter » */
    !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', id);
    window.fbq('track', 'PageView');
  }
  document.addEventListener('visitorConsentCollected', function (ev) { if (ev.detail && ev.detail.marketingAllowed) chargerPixel(); });
  var demarrerMesure = function () {
    confidentialite(function (cp) { if (cp.marketingAllowed && cp.marketingAllowed()) chargerPixel(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrerMesure); else demarrerMesure();

  var bandeau = $('#ln-cookies');
  function montrerBandeau(direct) {
    if (!bandeau) return;
    var go = function () { bandeau.hidden = false; requestAnimationFrame(function () { requestAnimationFrame(function () { bandeau.classList.add('is-on'); }); }); };
    if (direct === true) return go();
    /* on ne demande qu'au premier geste (défilement, toucher, touche) ou après 6 s : rien ne cache le premier écran */
    var fait = false, evts = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
    var une = function () { if (fait) return; fait = true; evts.forEach(function (e) { window.removeEventListener(e, une, true); }); setTimeout(go, 400); };
    evts.forEach(function (e) { window.addEventListener(e, une, { capture: true, passive: true }); });
    setTimeout(une, 6000);
  }
  function choisir(oui) {
    confidentialite(function (cp) {
      cp.setTrackingConsent({ analytics: oui, marketing: oui, preferences: oui, sale_of_data: oui }, function () { if (oui) chargerPixel(); });
    });
    bandeau.classList.remove('is-on');
    setTimeout(function () { bandeau.hidden = true; }, 320);
  }
  if (bandeau) {
    $('[data-oui]', bandeau).addEventListener('click', function () { choisir(true); });
    $('[data-non]', bandeau).addEventListener('click', function () { choisir(false); });
    var initCookies = function () {
      confidentialite(function (cp) {
        var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
        var aDemander = (cp.shouldShowBanner && cp.shouldShowBanner()) || (c && c.marketing === '');
        if (aDemander) montrerBandeau();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCookies); else initCookies();
  }
  $$('[data-cookies-ouvrir]').forEach(function (b) { b.addEventListener('click', function () { montrerBandeau(true); }); });

  function mesurerAjout(valeurCentimes, nb) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ln_ajout_panier', { valeur: valeurCentimes / 100, devise: 'EUR', livres: nb }); } catch (e) {}
    try { if (window.fbq && pixelCharge) window.fbq('track', 'AddToCart', { value: valeurCentimes / 100, currency: 'EUR', num_items: nb, content_type: 'product' }); } catch (e) {}
  }

  /* ================= 3. panier : compteur et garde du livre à 49 € ================= */
  function majCompteur(n) {
    $$('[data-panier-n]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
  }
  /* Un livre à 49 € n'existe qu'avec un livre principal : on retire les livres supplémentaires en trop. */
  function garderPanier(recharger) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var principaux = 0, extras = [];
      c.items.forEach(function (it) {
        if (it.handle === PRODUIT) principaux += it.quantity;
        else if (it.handle === SECOND) extras.push(it);
      });
      var nbExtras = extras.reduce(function (s, it) { return s + it.quantity; }, 0);
      var surplus = nbExtras - principaux;
      majCompteur(c.item_count);
      if (surplus <= 0) return false;
      var chaine = Promise.resolve();
      extras.reverse().forEach(function (it) {
        if (surplus <= 0) return;
        var retire = Math.min(surplus, it.quantity); surplus -= retire;
        chaine = chaine.then(function () {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: it.key, quantity: it.quantity - retire }) });
        });
      });
      return chaine.then(function () { if (recharger) location.reload(); return true; });
    }).catch(function () { return false; });
  }
  if (!corps.classList.contains('ln-edition')) garderPanier(!!$('[data-ln-panier]'));

  /* Le panier : « Retirer » demande confirmation sur place, puis retire sans quitter la page (le 2e livre lié part avec
     son livre principal, et c'est dit avant). Le lien garde son adresse Shopify : sans script, il marche quand même. */
  $$('[data-ln-panier] .pan__ligne').forEach(function (li) {
    var lien = $('[data-retirer]', li), conf = $('[data-confirme]', li); if (!lien || !conf) return;
    var lies = Number(lien.dataset.lies) || 0;
    if (lies) {
      var autres = $$('[data-ln-panier] .pan__ligne').filter(function (x) { return x !== li && x.dataset.lien && x.dataset.lien === li.dataset.lien; });
      var noms = autres.map(function (x) { var t = $('.pan__titre span', x); return t ? t.textContent.replace(/^2e livre/, '').replace(/^Le livre de /, '').trim() : ''; }).filter(Boolean);
      $('[data-confirme-txt]', li).textContent = 'Retirer ce livre ? Le 2e livre' + (noms.length ? ' (' + noms.join(', ') + ')' : '') + ' l\u2019accompagne : il sera retiré aussi.';
    }
    lien.addEventListener('click', function (ev) { ev.preventDefault(); conf.hidden = false; lien.parentNode.hidden = true; var o = $('[data-oui-retirer]', li); if (o) o.focus(); });
    $('[data-non-retirer]', li).addEventListener('click', function () { conf.hidden = true; lien.parentNode.hidden = false; lien.focus(); });
    $('[data-oui-retirer]', li).addEventListener('click', function () {
      var b = this; b.disabled = true; b.textContent = 'Un instant…';
      var cles = [li.dataset.cle];
      if (lies) $$('[data-ln-panier] .pan__ligne').forEach(function (x) { if (x !== li && x.dataset.lien && x.dataset.lien === li.dataset.lien) cles.push(x.dataset.cle); });
      var maj = {}; cles.forEach(function (k) { maj[k] = 0; });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: maj }) })
        .then(function (rep) { if (!rep.ok) throw new Error(); location.reload(); })
        .catch(function () { location.href = lien.href; });
    });
  });

  /* ================= 4. LA couverture (une seule fonction pour tout le site) ================= */
  /* Toute couverture du site passe par couverture(boite, etat) : le livre en volume de l'ouverture, de l'offre, du dernier mot
     et de l'atelier de création. Pour changer de modèle (v5 → v6), on ne touche qu'ici. */
  var PAL = {
    nuit: { fond: '#1e2433', accent: '#e2a72e', texte: '#fbf5ea', ruban: '#e2a72e', rubanT: '#1e2433' },
    sapin: { fond: '#1f5d4c', accent: '#f2b8a2', texte: '#fbf5ea', ruban: '#f2b8a2', rubanT: '#1f5d4c' },
    creme: { fond: '#f1e4cf', accent: '#d2603a', texte: '#1e2433', ruban: '#1e2433', rubanT: '#fbf5ea' }
  };
  var POS = [[30, 192], [94, 180], [160, 160], [118, 120], [42, 104]];
  var COUL = ['#d2603a', '#2e6b57', '#e2a72e', '#3c77a8', '#d9547a'];
  function route(texte, accent, auteurs) {
    var points = auteurs.map(function (a, i) {
      var x = POS[i][0], y = POS[i][1], c = COUL[i];
      return '<circle cx="' + x + '" cy="' + y + '" r="12.5" fill="none" stroke="' + c + '" stroke-width=".5" stroke-dasharray="1.2 1.2"/>' +
        '<circle cx="' + x + '" cy="' + y + '" r="9.5" fill="' + c + '" stroke="' + texte + '" stroke-opacity=".9" stroke-width=".7"/>' +
        '<text x="' + x + '" y="' + (y + 3.4) + '" text-anchor="middle" font-family="Fraunces" font-style="italic" font-weight="600" font-size="9.5" fill="#fff">' + (i + 1) + '</text>' +
        '<text x="' + x + '" y="' + (y + 19.5) + '" text-anchor="middle" font-family="Bricolage Grotesque" font-weight="700" font-size="5.4" fill="' + texte + '">' + esc(a[0]) + '</text>' +
        (a[1] ? '<text x="' + x + '" y="' + (y + 25.5) + '" text-anchor="middle" font-family="Bricolage Grotesque" font-size="4.3" fill="' + texte + '" fill-opacity=".75">' + a[1] + '</text>' : '');
    }).join('');
    var etoiles = [[92, 22], [156, 28], [150, 72], [88, 64]].map(function (p) {
      var x = p[0], y = p[1];
      return '<path d="M' + x + ',' + (y - 3.5) + ' L' + (x + 1) + ',' + (y - 1) + ' L' + (x + 3.5) + ',' + y + ' L' + (x + 1) + ',' + (y + 1) + ' L' + x + ',' + (y + 3.5) + ' L' + (x - 1) + ',' + (y + 1) + ' L' + (x - 3.5) + ',' + y + ' L' + (x - 1) + ',' + (y - 1) + 'Z" fill="' + accent + '"/>';
    }).join('');
    return '<svg viewBox="0 0 190 218" preserveAspectRatio="xMidYMax meet" aria-hidden="true">' +
      '<path d="M30,192 C60,192 64,180 94,180 C128,180 130,160 160,160 C188,160 176,120 118,120 C88,120 72,104 42,104 C8,104 14,46 98,46" fill="none" stroke="' + texte + '" stroke-opacity=".55" stroke-width="1.1" stroke-dasharray="2.4 2.6" stroke-linecap="round"/>' +
      points +
      '<circle cx="122" cy="46" r="27" fill="none" stroke="' + accent + '" stroke-width=".6" stroke-dasharray="1.4 1.6"/>' +
      '<circle cx="122" cy="46" r="22" fill="#d9547a" stroke="' + texte + '" stroke-width=".9"/>' +
      '<text x="122" y="47" text-anchor="middle" font-family="Fraunces" font-style="italic" font-weight="600" font-size="20" fill="#fff">18</text>' +
      '<text x="122" y="56.5" text-anchor="middle" font-family="Bricolage Grotesque" font-weight="700" font-size="4.4" letter-spacing=".5" fill="#fff">ANS</text>' +
      '<text x="122" y="83" text-anchor="middle" font-family="Bricolage Grotesque" font-weight="700" font-size="6" fill="' + texte + '">Le grand jour</text>' +
      etoiles + '</svg>';
  }
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var fdate = function (d) { return (d.getDate() === 1 ? '1er' : d.getDate()) + ' ' + MOIS[d.getMonth()] + ' ' + d.getFullYear(); };
  var fcourt = function (d) { var z = function (n) { return (n < 10 ? '0' : '') + n; }; return z(d.getDate()) + '/' + z(d.getMonth() + 1) + '/' + d.getFullYear(); };
  var parseD = function (v) { if (!v) return null; var t = v.split('-').map(Number); return new Date(t[0], (t[1] || 1) - 1, t[2] || 1); };

  function nouvelEtat(n) { return { n: n, couleur: 'nuit', prenom: '', genre: 'surprise', ne: 'oui', date: '', mois: '', photo: null, fichier: null, remise: '18', dateRemise: '', dedicace: '' }; }
  var etats = { 1: nouvelEtat(1), 2: nouvelEtat(2) };
  var commun = { offert: '', membres: [], pour: '', visages: [] };
  var actif = 1, avecSecond = false;
  /* le prénom tapé par la visiteuse (dernier mot, atelier) la suit d'une page à l'autre */
  var PERMIS_P = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]*$/;
  var prenomVisiteur = (function () {
    var q = new URLSearchParams(location.search).get('prenom');
    if (q && PERMIS_P.test(q)) { q = q.slice(0, 14); ecrire('ln-prenom', q); return q; }
    var l = lire('ln-prenom'); return (typeof l === 'string' && PERMIS_P.test(l)) ? l.slice(0, 14) : '';
  })();
  var etatExemple = nouvelEtat(1);
  var etatExempleCreme = nouvelEtat(1); etatExempleCreme.couleur = 'creme';
  var etatVisiteur = nouvelEtat(1); etatVisiteur.prenom = prenomVisiteur;
  if (prenomVisiteur) $$('[data-fin-prenom]').forEach(function (s) { s.textContent = prenomVisiteur; });

  function donnees(e) {
    var prenom = e.prenom.trim() || (e.n === 1 ? 'Léo' : 'Jeanne');
    var offert = commun.offert.trim() || 'Mamie Christine';
    var naissance = '', remise = '', age = Number(e.remise), dateRemise = null;
    if (e.ne === 'oui') {
      var d = parseD(e.date);
      naissance = d ? 'Naissance : ' + fdate(d) : 'Naissance : 14 mars 2026';
      var base = d || new Date(2026, 2, 14);
      if (e.remise !== 'autre') { dateRemise = new Date(base); dateRemise.setFullYear(base.getFullYear() + age); remise = 'le ' + fdate(dateRemise) + ',<br>le jour de tes ' + age + ' ans'; }
    } else {
      var m = parseD(e.mois);
      naissance = m ? 'Naissance prévue : ' + MOIS[m.getMonth()] + ' ' + m.getFullYear() : 'Naissance prévue';
      if (e.remise !== 'autre') remise = m ? 'en ' + (m.getFullYear() + age) + ',<br>le jour de tes ' + age + ' ans' : 'le jour de tes ' + age + ' ans';
    }
    if (e.remise === 'autre') { var r = parseD(e.dateRemise); dateRemise = r; remise = r ? 'le ' + fdate(r) : 'le grand jour que nous avons choisi'; }
    var premierMot = offert.split(/\s+/)[0].toLowerCase();
    var donnes = commun.membres.map(function (m) { return m.nom.trim(); }).filter(Boolean).filter(function (nm) { return nm.toLowerCase() !== offert.toLowerCase(); });
    var dejaDits = [premierMot].concat(donnes.map(function (nm) { return nm.split(/\s+/)[0].toLowerCase(); }));
    var defauts = ['Papi', 'Maman', 'Papa', 'Mamie'].filter(function (nm) { return dejaDits.indexOf(nm.toLowerCase()) < 0; });
    var milieu = donnes.concat(defauts).slice(0, 3);
    var auteurs = [[offert, 'commence']].concat(milieu.map(function (nm) { return [nm, '']; })).concat([['Toi', 'à ton tour']]);
    return { prenom: prenom, offert: offert, naissance: naissance, remise: remise, dateRemise: dateRemise, auteurs: auteurs, initiale: prenom.charAt(0).toUpperCase() };
  }
  /* ---------- la couverture « mur de famille » (v2, 14/10/2026) : de 0 à 12 vrais visages épinglés autour du prénom ----------
     Les dispositions viennent de maquette/illustrations/mur_dispositions.py, comme l'impression (mur2.py) : une par nombre
     de photos, jamais un cadre vide. Coordonnées dans le fond 3392 × 5056, recadré au format A4 (129 px rognés en haut et en bas). */
  var DISPOS = {"0":{"t":[],"c":[0.5,0.47,0.56,0.21]},"1":{"t":[[0.506,0.354,0.46,-5.5]],"c":[0.5,0.6748,0.5,0.19]},"2":{"t":[[0.506,0.2019,0.34,-5.5],[0.496,0.7461,0.34,4.2]],"c":[0.5,0.475,0.5,0.19]},"3":{"t":[[0.3212,0.198,0.33,-5.5],[0.6808,0.188,0.33,4.2],[0.503,0.7591,0.34,-2.8]],"c":[0.5,0.4711,0.5,0.19]},"4":{"t":[[0.3212,0.198,0.33,-5.5],[0.6808,0.188,0.33,4.2],[0.3182,0.763,0.33,-2.8],[0.6788,0.758,0.33,6.1]],"c":[0.5,0.475,0.5,0.19]},"5":{"t":[[0.2036,0.1745,0.27,-5.5],[0.496,0.1645,0.27,4.2],[0.8054,0.1775,0.27,-2.8],[0.3092,0.758,0.33,6.1],[0.6868,0.752,0.33,-4.6]],"c":[0.5,0.4516,0.5,0.19]},"6":{"t":[[0.3212,0.198,0.33,-5.5],[0.6808,0.188,0.33,4.2],[0.178,0.482,0.25,-2.8],[0.819,0.477,0.25,6.1],[0.3172,0.752,0.33,-4.6],[0.6898,0.762,0.33,3.0]],"c":[0.5,0.475,0.37,0.19]},"7":{"t":[[0.2036,0.1745,0.27,-5.5],[0.496,0.1645,0.27,4.2],[0.8054,0.1775,0.27,-2.8],[0.169,0.4536,0.25,6.1],[0.827,0.4476,0.25,-4.6],[0.3202,0.762,0.33,3.0],[0.6818,0.759,0.33,-6.4]],"c":[0.5,0.4516,0.37,0.19]},"8":{"t":[[0.2036,0.1745,0.27,-5.5],[0.496,0.1645,0.27,4.2],[0.8054,0.1775,0.27,-2.8],[0.169,0.477,0.25,6.1],[0.827,0.471,0.25,-4.6],[0.2026,0.7855,0.27,3.0],[0.497,0.7825,0.27,-6.4],[0.8064,0.7745,0.27,2.2]],"c":[0.5,0.475,0.37,0.19]},"9":{"t":[[0.167,0.1518,0.212,-5.5],[0.383,0.1418,0.212,4.2],[0.616,0.1548,0.212,-2.8],[0.833,0.1498,0.212,6.1],[0.158,0.4483,0.212,-4.6],[0.849,0.4583,0.212,3.0],[0.1946,0.7825,0.27,-6.4],[0.504,0.7745,0.27,2.2],[0.7974,0.7845,0.27,-3.6]],"c":[0.5,0.4523,0.37,0.19]},"10":{"t":[[0.167,0.1518,0.212,-5.5],[0.383,0.1418,0.212,4.2],[0.616,0.1548,0.212,-2.8],[0.833,0.1498,0.212,6.1],[0.158,0.471,0.212,-4.6],[0.849,0.481,0.212,3.0],[0.158,0.8052,0.212,-6.4],[0.391,0.7972,0.212,2.2],[0.608,0.8072,0.212,-3.6],[0.841,0.7992,0.212,5.4]],"c":[0.5,0.475,0.37,0.19]},"11":{"t":[[0.167,0.1518,0.212,-5.5],[0.383,0.1418,0.212,4.2],[0.616,0.1548,0.212,-2.8],[0.833,0.1498,0.212,6.1],[0.158,0.3575,0.212,-4.6],[0.849,0.3675,0.212,3.0],[0.153,0.5462,0.212,-6.4],[0.848,0.5382,0.212,2.2],[0.1926,0.7845,0.27,-3.6],[0.502,0.7765,0.27,5.4],[0.8084,0.7835,0.27,-1.8]],"c":[0.5,0.4523,0.37,0.19]},"12":{"t":[[0.167,0.1518,0.212,-5.5],[0.383,0.1418,0.212,4.2],[0.616,0.1548,0.212,-2.8],[0.833,0.1498,0.212,6.1],[0.158,0.3802,0.212,-4.6],[0.849,0.3902,0.212,3.0],[0.153,0.5688,0.212,-6.4],[0.848,0.5608,0.212,2.2],[0.156,0.8072,0.212,-3.6],[0.389,0.7992,0.212,5.4],[0.619,0.8062,0.212,-1.8],[0.837,0.7962,0.212,4.8]],"c":[0.5,0.475,0.37,0.19]}};
  var FOND_L = 3392, FOND_H = 5056, A4_Y0 = 129, A4_H = 4797, RATIO_T = 1.165;
  var murPortraits = (corps.dataset.murPortraits || '').split('|');
  var EXEMPLE_VISAGES = ['Arrière-grand-mère Lucienne', 'Mamie Christine', 'Papi Jean', 'Mamie Odile', 'Papi Gérard', 'Maman', 'Papa', ''];
  function visagesDe(mode, d) {
    if (mode === 'config') return commun.visages.filter(function (v) { return v && v.url; }).slice(0, 12).map(function (v) {
      return { url: v.url, leg: v.etiquette || '', x: v.x, y: v.y, zoom: v.zoom };
    });
    return murPortraits.map(function (u, i) { return { url: u, leg: i === 7 ? d.prenom + ', 2 jours' : EXEMPLE_VISAGES[i], x: 50, y: 50, zoom: 1 }; });
  }
  function yA4(y) { return ((y * FOND_H - A4_Y0) / A4_H * 100).toFixed(3); }
  function couverture(boite, e) {
    var d = donnees(e), mode = boite.dataset.couv, vis = visagesDe(mode, d), dp = DISPOS[String(vis.length)];
    var hd = (boite.clientWidth || 300) * (window.devicePixelRatio || 1) > 900;
    var tirages = dp.t.map(function (z, i) {
      var v = vis[i], x = v.x == null ? 50 : v.x, y = v.y == null ? 42 : v.y;
      return '<div class="mur__t" style="left:' + (z[0] * 100).toFixed(3) + '%;top:' + yA4(z[1]) + '%;width:' + (z[2] * 100).toFixed(3) + '%;font-size:' + (z[2] * 28.6).toFixed(2) + 'mm;transform:translate(-50%,-50%) rotate(' + z[3] + 'deg)">' +
        '<div class="mur__ph"><img src="' + esc(v.url) + '" alt="" style="object-position:' + x + '% ' + y + '%;transform:scale(' + (v.zoom || 1) + ')"></div>' +
        '<div class="mur__leg">' + esc(v.leg || '') + '</div>' +
        '<img class="mur__pince" src="' + esc(corps.dataset.murPince || '') + '" alt="" style="transform:translate(-50%,-50%) rotate(' + (3 - z[3] * .4).toFixed(1) + 'deg)"></div>';
    }).join('');
    var c = dp.c, ne = d.naissance.replace(/^Naissance( prévue)? : /, '');
    boite.innerHTML = '<div class="couv mur" role="img" aria-label="Couverture : ' + esc(d.prenom) + ', tout ce qu’on voulait que tu saches, entouré des visages de sa famille." style="background-image:url(' + esc(hd ? (corps.dataset.murHd || corps.dataset.mur) : corps.dataset.mur) + ')">' +
      tirages +
      '<div class="mur__carte" style="left:' + (c[0] * 100) + '%;top:' + yA4(c[1]) + '%;width:' + (c[2] * 100) + '%;height:' + (c[3] * FOND_H / A4_H * 100).toFixed(3) + '%"><i class="t1"></i><i class="t2"></i><div class="ti">tout ce qu’on voulait<br>que tu saches</div><div class="nom">' + esc(d.prenom) + '</div>' +
      (ne ? '<div class="ne">' + esc(ne) + '</div>' : '') + '</div>' +
      '<div class="mur__m">' + esc(corps.dataset.marque || '') + '</div></div>';
    var livre = boite.closest('[data-livre-3d]');
    if (livre) {
      livre.style.setProperty('--dos', '#efe7d9');
      $$('[data-prenom-vivant]', livre).forEach(function (s) { s.textContent = d.prenom; });
    }
    echelle(boite, e);
  }
  function echelle(boite, e) {
    var c = $('.couv', boite); if (!c || !boite.clientWidth) return;
    c.style.transform = 'scale(' + (boite.clientWidth / c.offsetWidth) + ')';
    $$('.mur__leg', c).forEach(function (l) { var t = 100; l.style.fontSize = ''; while (l.scrollWidth > l.clientWidth && t > 45) { t -= 5; l.style.fontSize = t + '%'; } });
    var nom = $('.nom', c), carte = $('.mur__carte', c); if (!nom || !carte) return;
    var place = carte.clientWidth * .86, taille = carte.clientWidth > 300 ? 72 : 60;
    nom.style.fontSize = taille + 'pt';
    while (nom.offsetWidth > place && taille > 20) { taille -= 2; nom.style.fontSize = taille + 'pt'; }
  }
  var boites = $$('[data-couv]');
  function etatDe(b) { var m = b.dataset.couv; return m === 'config' ? etats[actif] : m === 'exemple' ? etatExemple : m === 'exemple-creme' ? etatExempleCreme : etatVisiteur; }
  function tout() { boites.forEach(function (b) { couverture(b, etatDe(b)); }); }
  if (boites.length) {
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (ents) { ents.forEach(function (en) { echelle(en.target, etatDe(en.target)); }); });
      boites.forEach(function (b) { ro.observe(b); });
    }
    tout();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(tout);
  }

  /* le dernier mot : la visiteuse essaie avec le prénom de son petit-enfant */
  var essai = $('[data-prenom-essai]');
  function majLiensAtelier() {
    $$('[data-vers-atelier], [data-ln-cta]').forEach(function (a) {
      try { var u = new URL(a.getAttribute('href'), location.href); if (etatVisiteur.prenom) u.searchParams.set('prenom', etatVisiteur.prenom); else u.searchParams.delete('prenom'); a.setAttribute('href', u.pathname + u.search + u.hash); } catch (e) {}
    });
  }
  if (essai) {
    essai.value = prenomVisiteur;
    essai.addEventListener('input', function () {
      var v = essai.value; if (!PERMIS_P.test(v)) return;
      etatVisiteur.prenom = v; ecrire('ln-prenom', v.trim()); tout(); majLiensAtelier();
      $$('[data-fin-prenom]').forEach(function (s) { s.textContent = v.trim() || 'Léo'; });
    });
  }
  majLiensAtelier();

  /* ================= 5. l'atelier de création ================= */
  var form = $('#ln-form');
  if (form) {
    var PERMIS = PERMIS_P;
    var prix1 = Number(form.dataset.prix) || 7900, prix2 = Number(form.dataset.prixSecond) || 4900;
    var dans = function (n, sel) { return $$('[data-livre="' + n + '"]', form).map(function (z) { return z.matches(sel) ? z : $(sel, z); }).filter(Boolean)[0]; };
    var erreur = function (id, msg) { var p = document.getElementById(id); if (!p) return; p.textContent = msg || ''; p.hidden = !msg; };
    var compte = function (id, val, max) { var c = document.getElementById(id); if (c) c.textContent = val.length + ' / ' + max; };

    var exemples = [['Papi Jean', 'le papa de ta maman'], ['Maman', ''], ['Papa', ''], ['Mamie Monique', 'la maman de ton papa'], ['Tata Inès', 'la sœur de ton papa'], ['', '']];
    var zoneMembres = $('#membres');
    if (zoneMembres) {
      zoneMembres.innerHTML = exemples.map(function (x, i) {
        return '<div class="membre"><input type="text" maxlength="24" data-m="' + i + '" data-k="nom" placeholder="' + esc(x[0] || 'Surnom') + '" aria-label="Auteur ' + (i + 1) + ', surnom">' +
          '<input type="text" maxlength="40" data-m="' + i + '" data-k="lien" placeholder="' + esc(x[1] || "Son lien avec l'enfant (facultatif)") + '" aria-label="Auteur ' + (i + 1) + ', lien avec l\'enfant"></div>';
      }).join('');
      commun.membres = exemples.map(function () { return { nom: '', lien: '' }; });
    }

    function montrerLivre(n) {
      actif = n;
      $$('#ln-onglets [data-onglet]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.onglet) === n)); });
      tout();
    }
    function majOnglets() {
      var o = $('#ln-onglets'); if (!o) return;
      o.hidden = !avecSecond;
      var b1 = $('[data-onglet="1"]', o), b2 = $('[data-onglet="2"]', o);
      b1.textContent = 'Livre de ' + (etats[1].prenom.trim() || 'Léo');
      b2.textContent = 'Livre de ' + (etats[2].prenom.trim() || 'son frère ou sa sœur');
    }
    $$('#ln-onglets [data-onglet]').forEach(function (b) { b.addEventListener('click', function () { montrerLivre(Number(b.dataset.onglet)); }); });

    function prix() {
      var total = prix1 + (avecSecond ? prix2 : 0);
      var t2 = $('#t-second'); if (t2) t2.hidden = !avecSecond;
      $('#t-total').textContent = euros2(total);
      $('#b-total').textContent = euros(total);
      $('#t-prenom').textContent = etats[1].prenom.trim() || 'Léo';
      var tp2 = $('#t-prenom-2'); if (tp2) tp2.textContent = etats[2].prenom.trim() || 'son frère ou sa sœur';
    }

    form.addEventListener('input', function (ev) {
      var t = ev.target, zone = t.closest('[data-livre]');
      if (t.dataset.m) { commun.membres[t.dataset.m][t.dataset.k] = t.value; tout(); return; }
      if (t.name === 'pour') { pourQui(t.value); return; }
      if (!zone) return;
      var n = Number(zone.dataset.livre), e = etats[n], c = t.dataset.champ;
      if (avecSecond && actif !== n) montrerLivre(n);
      if (t.name === 'couleur-' + n) e.couleur = t.value;
      if (t.name === 'genre-' + n) e.genre = t.value;
      if (t.name === 'ne-' + n) {
        e.ne = t.value;
        dans(n, '[data-zone="date"]').hidden = t.value !== 'oui';
        dans(n, '[data-zone="mois"]').hidden = t.value === 'oui';
      }
      if (c === 'prenom') { e.prenom = t.value; compte('c-prenom-' + n, t.value, 14); if (PERMIS.test(t.value)) erreur('e-prenom-' + n); if (n === 1 && PERMIS.test(t.value)) ecrire('ln-prenom', t.value.trim()); }
      if (c === 'offert') { commun.offert = t.value; compte('c-offert', t.value, 24); if (t.value.trim()) erreur('e-offert'); }
      if (c === 'date') e.date = t.value;
      if (c === 'mois') e.mois = t.value;
      if (c === 'remise') { e.remise = t.value; dans(n, '[data-zone="remise"]').hidden = t.value !== 'autre'; }
      if (c === 'dateRemise') e.dateRemise = t.value;
      if (c === 'dedicace') { e.dedicace = t.value; compte('c-dedicace-' + n, t.value, 240); if (n === 1) majDedicace(false); }
      if (c === 'offert') majDedicace(false);
      majOnglets(); prix(); tout();
    });

    var caseSecond = $('#second');
    if (caseSecond) caseSecond.addEventListener('change', function () {
      avecSecond = caseSecond.checked;
      $('#ln-livre-2').hidden = !avecSecond;
      majOnglets(); prix();
      montrerLivre(avecSecond ? 2 : 1);
      if (avecSecond) { var p2 = $('#prenom-2'); if (p2) p2.focus({ preventScroll: false }); }
    });

    [1, 2].forEach(function (n) {
      var input = $('#photo-' + n); if (!input) return;
      var fs = input.closest('fieldset'), info = $('[data-info-photo]', fs), retirer = $('[data-retirer-photo]', fs);
      var infoDefaut = info.textContent;
      input.addEventListener('change', function () {
        var f = input.files && input.files[0]; if (!f) return;
        if (!/^image\/(jpeg|png)$/.test(f.type)) { info.textContent = 'Ce format n\'est pas accepté : choisissez une photo JPG ou PNG.'; input.value = ''; return; }
        if (f.size > 15 * 1024 * 1024) { info.textContent = 'Cette photo dépasse 15 Mo : choisissez-en une plus légère (une photo de téléphone convient).'; input.value = ''; return; }
        var r = new FileReader();
        r.onload = function () {
          var img = new Image();
          img.onload = function () {
            var petit = Math.min(img.naturalWidth, img.naturalHeight) < 1200;
            info.textContent = petit
              ? 'Cette photo fait ' + img.naturalWidth + ' × ' + img.naturalHeight + ' pixels : elle risque d\'être floue à l\'impression. Essayez l\'original si vous l\'avez.'
              : 'Photo ajoutée. Nous vérifions le cadrage avant l\'impression.';
            etats[n].photo = r.result; etats[n].fichier = f; retirer.hidden = false;
            if (avecSecond) montrerLivre(n); else tout();
          };
          img.onerror = function () { info.textContent = 'Cette photo ne s\'ouvre pas : essayez-en une autre.'; input.value = ''; };
          img.src = r.result;
        };
        r.readAsDataURL(f);
      });
      retirer.addEventListener('click', function () {
        etats[n].photo = null; etats[n].fichier = null; input.value = ''; retirer.hidden = true; info.textContent = infoDefaut; tout();
      });
    });

    /* ----- les visages de sa famille : jusqu'à 12 photos épinglées autour du prénom (couverture « mur ») ;
       on montre les cadres remplis et un seul cadre vide de plus, pour ne jamais présenter 12 cases à remplir ----- */
    var QUI = ['Mamie', 'Papi', 'Maman', 'Papa', 'Tata', 'Tonton', 'Parrain', 'Marraine', 'Arrière-grand-mère', 'Arrière-grand-père', 'Frère ou sœur', 'Autre'];
    var zoneV = $('[data-visages]', form);
    function etiquette(v) {
      var pr = (v.prenom || '').trim();
      if (!v.qui || v.qui === 'Autre') return pr;
      if (v.qui === 'Frère ou sœur') return pr || 'Frère ou sœur';
      return pr ? v.qui + ' ' + pr : v.qui;
    }
    /* Les visages (15/10/2026, pensé d'abord pour le téléphone) : on choisit plusieurs photos d'un coup dans la galerie,
       puis chaque nouvelle photo s'ouvre dans un grand panneau : placer le visage (glisser, pincer), dire qui c'est, « Suivante ». */
    var montrer = function () {};
    if (zoneV) {
      commun.visages = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function () { return { url: '', fichier: null, qui: '', prenom: '', x: 50, y: 38, zoom: 1, etiquette: '' }; });
      zoneV.innerHTML = '<div class="vz__grille" data-vz-grille></div>' +
        '<button type="button" class="vz__ajout" data-vz-ajout><span aria-hidden="true">+</span> Ajouter des photos</button>' +
        '<input type="file" accept="image/jpeg,image/png" multiple class="ln-sr" tabindex="-1" data-vz-fichiers aria-label="Choisir des photos">' +
        '<p class="aide vz__msg" data-vz-msg role="status" hidden></p>' +
        '<dialog class="vz-f" data-vz-feuille aria-labelledby="vz-f-t"><div class="vz-f__in">' +
          '<div class="vz-f__h"><p class="vz-f__t" id="vz-f-t" data-vz-num>Photo 1</p><button type="button" class="vz-f__x" data-vz-fermer aria-label="Fermer">×</button></div>' +
          '<div class="vz-f__cadre" data-vz-cadre><img alt="" draggable="false"></div>' +
          '<p class="vz-f__geste">Glissez pour placer le visage, pincez pour zoomer</p>' +
          '<label class="vz-f__zoom"><span>Zoom</span><input type="range" min="1" max="2.5" step="0.05" value="1" data-vz-zoom></label>' +
          '<p class="t" id="vz-qui-t">Qui est-ce&#8239;?</p>' +
          '<div class="vz-puces" role="group" aria-labelledby="vz-qui-t" data-vz-puces>' + QUI.map(function (q) { return '<button type="button" aria-pressed="false" data-q="' + esc(q) + '">' + esc(q) + '</button>'; }).join('') + '</div>' +
          '<label class="t" for="vz-prenom">Son prénom <span class="aide">(facultatif)</span></label>' +
          '<input type="text" id="vz-prenom" maxlength="18" autocomplete="off" autocapitalize="words" data-vz-prenom placeholder="Christine">' +
          '<p class="aide vz-f__info" data-vz-info hidden></p>' +
          '<div class="vz-f__nav"><button type="button" class="vz-f__retirer" data-vz-retirer>Retirer</button><button type="button" class="l-btn l-btn--encre" data-vz-ok>Valider</button></div>' +
        '</div></dialog>';
      var grille = $('[data-vz-grille]', zoneV), bAjoutV = $('[data-vz-ajout]', zoneV), entree = $('[data-vz-fichiers]', zoneV), msgV = $('[data-vz-msg]', zoneV);
      var feuille = $('[data-vz-feuille]', zoneV), cadreF = $('[data-vz-cadre]', feuille), imgF = $('img', cadreF), zoomF = $('[data-vz-zoom]', feuille);
      var prenomF = $('[data-vz-prenom]', feuille), infoF = $('[data-vz-info]', feuille), numF = $('[data-vz-num]', feuille), okF = $('[data-vz-ok]', feuille);
      var enCours = -1, file = [], avertis = {};
      var remplis = function () { return commun.visages.map(function (v, k) { return v.url ? k : -1; }).filter(function (k) { return k >= 0; }); };
      var cadrer = function (img, v) { img.style.objectPosition = v.x + '% ' + v.y + '%'; img.style.transform = 'scale(' + v.zoom + ')'; };
      montrer = function () {
        var r = remplis();
        grille.innerHTML = r.map(function (k) {
          var v = commun.visages[k], et = etiquette(v);
          return '<button type="button" class="vz__v' + (et ? '' : ' is-anonyme') + '" data-vz-v="' + k + '" aria-label="Photo ' + (r.indexOf(k) + 1) + (et ? ' : ' + esc(et) : ' : dire qui c’est') + '">' +
            '<span class="vz__ph"><img src="' + esc(v.url) + '" alt="" style="object-position:' + v.x + '% ' + v.y + '%;transform:scale(' + v.zoom + ')"></span>' +
            '<span class="vz__et">' + (et ? esc(et) : 'Qui est-ce&#8239;?') + '</span></button>';
        }).join('') + (r.length && r.length < 12 ? '<button type="button" class="vz__v vz__plus" data-vz-plus aria-label="Ajouter des photos"><span class="vz__ph">+</span><span class="vz__et">Ajouter</span></button>' : '');
        bAjoutV.hidden = r.length > 0;
        var z = $('[data-compte-visages]', form); if (z) z.textContent = r.length ? r.length + ' photo' + (r.length > 1 ? 's' : '') + ' sur 12 · touchez une photo pour la modifier' : '';
      };
      var majTout = function () { tout(); recapSiVisible(); };
      var ouvrirVisage = function (k) {
        enCours = k; var v = commun.visages[k], r = remplis();
        imgF.src = v.url; cadrer(imgF, v); zoomF.value = v.zoom; prenomF.value = v.prenom;
        $$('[data-q]', feuille).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.q === v.qui)); });
        numF.textContent = 'Photo ' + (r.indexOf(k) + 1) + ' sur ' + r.length;
        infoF.hidden = !avertis[k]; infoF.textContent = avertis[k] || '';
        var reste = file.filter(function (x) { return x !== k; }).length;
        okF.textContent = reste ? 'Suivante' : 'Valider';
        if (!feuille.open) { if (feuille.showModal) feuille.showModal(); else feuille.setAttribute('open', ''); }
        cadreF.scrollIntoView && feuille.scrollTo && feuille.scrollTo(0, 0);
      };
      var fermerF = function () { file = []; enCours = -1; if (feuille.close) feuille.close(); else feuille.removeAttribute('open'); montrer(); majTout(); };
      var suivante = function () {
        file = file.filter(function (x) { return x !== enCours; });
        montrer(); majTout();
        if (file.length) ouvrirVisage(file[0]); else fermerF();
      };
      var choisirPhotos = function () { entree.value = ''; entree.click(); };
      bAjoutV.addEventListener('click', choisirPhotos);
      grille.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-vz-plus]')) { choisirPhotos(); return; }
        var b = ev.target.closest('[data-vz-v]'); if (b) { file = []; ouvrirVisage(Number(b.dataset.vzV)); }
      });
      /* plusieurs photos d'un coup : chacune prend la première place libre, puis on les nomme une à une */
      entree.addEventListener('change', function () {
        var fs = Array.prototype.slice.call(entree.files || []); if (!fs.length) return;
        var libres = commun.visages.map(function (v, k) { return v.url ? -1 : k; }).filter(function (k) { return k >= 0; });
        var refus = [], nouvelles = [], attente = 0;
        if (fs.length > libres.length) refus.push((fs.length - libres.length) + ' photo' + (fs.length - libres.length > 1 ? 's' : '') + ' de trop : 12 au plus.');
        fs.slice(0, libres.length).forEach(function (f, n) {
          var k = libres[n];
          if (!/^image\/(jpeg|png)$/.test(f.type)) { refus.push('« ' + f.name + ' » n’est pas une photo JPG ou PNG.'); return; }
          if (f.size > 15 * 1024 * 1024) { refus.push('« ' + f.name + ' » dépasse 15 Mo.'); return; }
          attente++;
          var url = URL.createObjectURL(f), test = new Image();
          var fini = function () { attente--; if (attente) return; msgV.hidden = !refus.length; msgV.textContent = refus.join(' '); montrer(); majTout(); nouvelles.sort(function (a, b) { return a - b; }); file = nouvelles.slice(); if (file.length) ouvrirVisage(file[0]); };
          test.onload = function () {
            var cote = Math.min(test.naturalWidth, test.naturalHeight);
            if (cote < 400) { refus.push('Une photo est trop petite (' + test.naturalWidth + ' × ' + test.naturalHeight + ' pixels) : elle serait floue.'); URL.revokeObjectURL(url); fini(); return; }
            var v = commun.visages[k]; v.url = url; v.fichier = f; v.distante = ''; v.x = 50; v.y = 38; v.zoom = 1; v.qui = ''; v.prenom = ''; v.etiquette = '';
            avertis[k] = cote < 800 ? 'Photo un peu petite (' + test.naturalWidth + ' × ' + test.naturalHeight + ' pixels) : elle peut manquer de netteté.' : '';
            nouvelles.push(k); fini();
          };
          test.onerror = function () { refus.push('Une photo ne s’ouvre pas.'); fini(); };
          test.src = url;
        });
        if (!attente) { msgV.hidden = !refus.length; msgV.textContent = refus.join(' '); }
      });
      /* placer le visage : un doigt glisse, deux doigts pincent (ou la molette du zoom) */
      var doigts = {}, depart = null;
      var poserVisage = function () { var v = commun.visages[enCours]; if (v) cadrer(imgF, v); };
      cadreF.addEventListener('pointerdown', function (ev) {
        if (enCours < 0) return; doigts[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
        try { cadreF.setPointerCapture(ev.pointerId); } catch (e) {}
        var v = commun.visages[enCours], ids = Object.keys(doigts);
        if (ids.length === 1) depart = { mode: 'glisse', x: ev.clientX, y: ev.clientY, vx: v.x, vy: v.y };
        if (ids.length === 2) { var a = doigts[ids[0]], b = doigts[ids[1]]; depart = { mode: 'pince', d: Math.hypot(a.x - b.x, a.y - b.y), z: v.zoom }; }
      });
      cadreF.addEventListener('pointermove', function (ev) {
        if (!depart || !doigts[ev.pointerId]) return;
        doigts[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
        var v = commun.visages[enCours], r = cadreF.getBoundingClientRect(), ids = Object.keys(doigts);
        if (depart.mode === 'glisse' && ids.length === 1) {
          var k = 100 / (r.width * v.zoom);
          v.x = Math.max(0, Math.min(100, depart.vx - (ev.clientX - depart.x) * k));
          v.y = Math.max(0, Math.min(100, depart.vy - (ev.clientY - depart.y) * k));
        } else if (depart.mode === 'pince' && ids.length === 2) {
          var a = doigts[ids[0]], b = doigts[ids[1]];
          v.zoom = Math.max(1, Math.min(2.5, depart.z * Math.hypot(a.x - b.x, a.y - b.y) / (depart.d || 1))); zoomF.value = v.zoom;
        }
        poserVisage();
      });
      var lever = function (ev) { delete doigts[ev.pointerId]; if (!Object.keys(doigts).length) { depart = null; majTout(); } else if (enCours >= 0) { var id = Object.keys(doigts)[0], v = commun.visages[enCours]; depart = { mode: 'glisse', x: doigts[id].x, y: doigts[id].y, vx: v.x, vy: v.y }; } };
      cadreF.addEventListener('pointerup', lever); cadreF.addEventListener('pointercancel', lever);
      zoomF.addEventListener('input', function () { var v = commun.visages[enCours]; if (!v) return; v.zoom = Number(zoomF.value); poserVisage(); majTout(); });
      $('[data-vz-puces]', feuille).addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-q]'); if (!b || enCours < 0) return; var v = commun.visages[enCours];
        v.qui = v.qui === b.dataset.q ? '' : b.dataset.q; v.etiquette = etiquette(v);
        $$('[data-q]', feuille).forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.q === v.qui)); });
        majTout();
      });
      prenomF.addEventListener('input', function () { var v = commun.visages[enCours]; if (!v) return; v.prenom = prenomF.value; v.etiquette = etiquette(v); majTout(); });
      prenomF.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); ev.stopPropagation(); suivante(); } });
      okF.addEventListener('click', suivante);
      $('[data-vz-fermer]', feuille).addEventListener('click', fermerF);
      feuille.addEventListener('cancel', function (ev) { ev.preventDefault(); fermerF(); });
      $('[data-vz-retirer]', feuille).addEventListener('click', function () {
        var v = commun.visages[enCours]; if (!v) return;
        if (v.url && !v.distante) URL.revokeObjectURL(v.url);
        v.url = ''; v.fichier = null; v.distante = ''; v.qui = ''; v.prenom = ''; v.etiquette = ''; delete avertis[enCours];
        suivante();
      });
    }
    if (zoneV) montrer();
    function visagesRemplis() { return commun.visages.filter(function (v) { return v && (v.fichier || v.distante); }); }
    function recapSiVisible() { try { recap(); } catch (e) {} }

    /* pour qui est ce livre : maman, grand-parent ou proche ; les textes s'adaptent, le tutoiement de l'enfant ne change pas */
    var POUR = { enfant: { achete: 'Maman ou papa', recap: 'mon enfant', offert: 'Maman', place: 'Maman' }, 'petit-enfant': { achete: 'Grand-parent', recap: 'mon petit-enfant', offert: '', place: 'Mamie Christine' }, proche: { achete: 'Autre', recap: 'un enfant que j\u2019aime', offert: '', place: 'Tata Inès' } };
    var offertAuto = '';
    function pourQui(v) {
      commun.pour = v; erreur('e-pour');
      var o = $('#offert'); if (!o || !POUR[v]) return;
      o.placeholder = POUR[v].place;
      if (!o.value || o.value === offertAuto) { o.value = POUR[v].offert; offertAuto = POUR[v].offert; commun.offert = o.value; compte('c-offert', o.value, 24); }
      tout();
    }
    /* les contrôles, un par sujet, pour pouvoir valider étape par étape */
    var auj = new Date(); auj.setHours(0, 0, 0, 0);
    var C = {
      prenom: function (n) {
        var pr = etats[n].prenom.trim();
        if (!pr) return ['e-prenom-' + n, 'Indiquez le prénom de l\'enfant : il s\'imprime sur la couverture.', '#prenom-' + n];
        if (!PERMIS.test(pr)) return ['e-prenom-' + n, 'Lettres, accents, tirets et espaces seulement.', '#prenom-' + n];
        return ['e-prenom-' + n];
      },
      naissance: function (n) {
        var e = etats[n];
        if (e.ne === 'oui') {
          var d = parseD(e.date);
          if (!d) return ['e-naissance-' + n, 'Indiquez sa date de naissance.', '#date-' + n];
          if (d > auj) return ['e-naissance-' + n, 'Cette date est à venir : choisissez « Bientôt là » et le mois prévu.', '#date-' + n];
          return ['e-naissance-' + n];
        }
        if (!parseD(e.mois)) return ['e-naissance-' + n, 'Indiquez le mois prévu de sa naissance.', '#mois-' + n];
        return ['e-naissance-' + n];
      },
      remise: function (n) {
        var e = etats[n];
        if (e.remise === 'autre') { var r = parseD(e.dateRemise); if (!r || r <= auj) return ['e-remise-' + n, 'Choisissez une date de remise à venir.', '#date-remise-' + n]; }
        return ['e-remise-' + n];
      },
      dedicace: function (n) {
        if (etats[n].dedicace.split('\n').length > 5) return ['e-dedicace-' + n, '5 lignes au maximum, pour tenir sur la page 1.', '#dedicace-' + n];
        return ['e-dedicace-' + n];
      },
      pour: function () {
        if (!commun.pour) return ['e-pour', 'Dites-nous pour qui est ce livre.', 'input[name="pour"]'];
        return ['e-pour'];
      },
      offert: function () {
        if (!commun.offert.trim()) return ['e-offert', 'Indiquez votre nom : il ouvre le premier chapitre.', '#offert'];
        return ['e-offert'];
      }
    };
    function verifier(liste) {
      var ok = true, premier = null;
      liste.forEach(function (x) { var r = C[x[0]](x[1]); erreur(r[0], r[1]); if (r[1]) { ok = false; if (!premier) premier = $(r[2]); } });
      return { ok: ok, premier: premier };
    }
    function valider(n) {
      var l = [['prenom', n], ['naissance', n], ['remise', n], ['dedicace', n]];
      if (n === 1) { l.push(['offert', 1]); l.push(['pour', 1]); }
      return verifier(l);
    }

    var COULEURS = { nuit: 'Nuit', sapin: 'Sapin', creme: 'Crème' };
    var GENRES = { fille: 'Fille', garcon: 'Garçon', surprise: 'Surprise (tournures neutres)' };
    var REMISES = { 18: 'Le jour de ses 18 ans', 15: 'Le jour de ses 15 ans', 10: 'Le jour de ses 10 ans' };
    function proprietes(n, lien) {
      var e = etats[n], d = donnees(e), l = [];
      l.push(['Prénom', e.prenom.trim()]);
      l.push(['Couverture', 'Mur de famille, ' + visagesRemplis().length + ' visage' + (visagesRemplis().length > 1 ? 's' : '')]);
      l.push(['Fille ou garçon', GENRES[e.genre]]);
      if (e.ne === 'oui') l.push(['Date de naissance', fcourt(parseD(e.date))]);
      else { var m = parseD(e.mois); l.push(['Naissance prévue', MOIS[m.getMonth()] + ' ' + m.getFullYear()]); }
      l.push(['Offert par', commun.offert.trim()]);
      if (POUR[commun.pour]) l.push(['Acheté par', POUR[commun.pour].achete]);
      if (e.remise === 'autre') l.push(['Remise', 'Le ' + fcourt(parseD(e.dateRemise))]);
      else if (d.dateRemise) l.push(['Remise', e.remise + ' ans, le ' + fcourt(d.dateRemise)]);
      else { var mp = parseD(e.mois); l.push(['Remise', e.remise + ' ans' + (mp ? ', en ' + MOIS[mp.getMonth()] + ' ' + (mp.getFullYear() + Number(e.remise)) : '')]); }
      if (e.dedicace.trim()) l.push(['Dédicace', e.dedicace.trim()]);
      var fam = commun.membres.filter(function (m) { return m.nom.trim(); });
      if (fam.length) l.push(['Famille', fam.map(function (m) { return m.nom.trim() + (m.lien.trim() ? ' (' + m.lien.trim() + ')' : ''); }).join(' · ')]);
      l.push(['_livre', String(n)]);
      l.push(['_lien', lien]);
      if (fam.length) l.push(['_famille', JSON.stringify(fam)]);
      visagesRemplis().forEach(function (v, i) { l.push(['Visage ' + (i + 1), v.etiquette || '(sans légende)']); l.push(['_cadrage ' + (i + 1), JSON.stringify({ x: Math.round(v.x), y: Math.round(v.y), zoom: v.zoom })]); });
      l.push(['_maquette', 'mur']);
      return l;
    }
    function message(txt, type) {
      var m = $('#ln-message'); m.textContent = txt; m.className = 'ln-message' + (type ? ' ln-message--' + type : ''); m.hidden = !txt;
    }
    function ajouterLivre(variante, n, lien) {
      var fd = new FormData();
      fd.append('id', variante);
      fd.append('quantity', '1');
      proprietes(n, lien).forEach(function (p) { fd.append('properties[' + p[0] + ']', p[1]); });
      visagesRemplis().forEach(function (v, i) { if (v.fichier) fd.append('properties[Photo famille ' + (i + 1) + ']', v.fichier, v.fichier.name || ('visage-' + (i + 1) + '.jpg')); else fd.append('properties[Photo famille ' + (i + 1) + ']', v.distante); });
      return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Le panier n\'a pas répondu.');
          return j;
        });
      });
    }

    /* ----- les étapes ----- */
    var PAS = $$('[data-pas]', form), total = PAS.length, pas = 1;
    var CONTROLES = { 1: [['pour', 1]], 2: [['prenom', 1]], 4: [['naissance', 1]], 5: [['offert', 1], ['dedicace', 1]], 6: [['remise', 1]] };
    var bPrec = $('[data-cre-prec]', form), bSuiv = $('[data-cre-suiv]', form), bAjout = $('#ln-ajouter');
    var num = $('[data-cre-num]', form), barre = $('.cre__barre', form);
    var NOMS = ['', 'Pour qui', 'Son prénom', 'Sa couverture', 'Sa naissance', 'Vous commencez', 'La remise', 'La famille', 'Récapitulatif'];
    var panneau = $('.cre__panneau'), PAS_COUV = 3, PAS_DEDICACE = 5, PAS_FAMILLE = 7;
    /* la page 1 dans l'aperçu : la dédicace s'écrit à la main pendant qu'on la tape */
    var sceneCre = $('.cre__scene'), dedTexte = $('[data-ded-texte]'), dedAuteur = $('[data-ded-auteur]'), dedMinute = null;
    function majDedicace(plume) {
      if (!dedTexte) return;
      var t = etats[1].dedicace.trim(), qui = commun.offert.trim() || (POUR[commun.pour] ? POUR[commun.pour].place : 'Mamie Christine');
      if (dedAuteur) dedAuteur.textContent = qui;
      clearTimeout(dedMinute);
      dedTexte.classList.toggle('is-vide', !t);
      if (!t) { dedTexte.textContent = 'Votre dédicace s\u2019écrira ici, de votre main.'; return; }
      var signe = '\n' + qui;
      if (!plume || reduit()) { dedTexte.textContent = t + signe; dedTexte.classList.add('is-plume'); return; }
      /* à l'ouverture : la dédicace déjà tapée s'écrit lettre après lettre */
      var k = 0, tout_ = t + signe, pasT = Math.max(12, Math.min(45, 1600 / tout_.length));
      dedTexte.textContent = ''; dedTexte.classList.add('is-plume');
      (function lettre() { k++; dedTexte.textContent = tout_.slice(0, k); if (k < tout_.length) dedMinute = setTimeout(lettre, pasT); })();
    }
    function recap() {
      var e = etats[1], d = donnees(e), dl = $('[data-recap]', form); if (!dl) return;
      var lignes = [
        ['Pour', POUR[commun.pour] ? POUR[commun.pour].recap : '…', 1],
        ['Prénom', esc(e.prenom.trim() || '…') + ' (' + GENRES[e.genre].replace(' (tournures neutres)', '').toLowerCase() + ')', 2],
        ['Couverture', (function () { var vs = visagesRemplis(); return vs.length ? 'Mur de famille : ' + vs.map(function (v) { return esc(v.etiquette || 'un visage'); }).join(', ') : 'Mur de famille, avec ses illustrations'; })(), 3],
        [e.ne === 'oui' ? 'Naissance' : 'Naissance prévue', e.ne === 'oui' ? (parseD(e.date) ? fdate(parseD(e.date)) : '…') : (parseD(e.mois) ? MOIS[parseD(e.mois).getMonth()] + ' ' + parseD(e.mois).getFullYear() : '…'), 4],
        ['Commencé par', esc(commun.offert.trim() || '…') + (e.dedicace.trim() ? ', avec une dédicace' : ''), 5],
        ['Remis', e.remise === 'autre' ? (parseD(e.dateRemise) ? 'le ' + fdate(parseD(e.dateRemise)) : '…') : REMISES[e.remise] + (d.dateRemise ? ', le ' + fdate(d.dateRemise) : ''), 6]
      ];
      var fam = commun.membres.filter(function (m) { return m.nom.trim(); }).map(function (m) { return esc(m.nom.trim()); });
      lignes.push(['La famille', fam.length ? fam.join(', ') : 'Chacun écrira son nom à la main', 7]);
      dl.innerHTML = lignes.map(function (l) { return '<div><dt>' + l[0] + '</dt><dd>' + l[1] + '</dd><button type="button" data-aller="' + l[2] + '">Modifier</button></div>'; }).join('');
    }
    function aller(n, focus) {
      var avant = pas;
      pas = Math.max(1, Math.min(total, n));
      PAS.forEach(function (z) {
        var vue = Number(z.dataset.pas) === pas;
        z.hidden = !vue;
        z.classList.remove('is-entre', 'is-revient');
        if (vue && avant !== pas && !reduit()) { void z.offsetWidth; z.classList.add(pas > avant ? 'is-entre' : 'is-revient'); }
      });
      num.textContent = 'Étape ' + pas + ' sur ' + total + ' : ' + NOMS[pas];
      barre.style.setProperty('--p', Math.round(pas / total * 100) + '%');
      bPrec.hidden = pas === 1;
      bSuiv.hidden = pas === total || (pas === 1 && !commun.pour);
      bAjout.hidden = pas !== total;
      form.classList.toggle('sans-nav', bPrec.hidden && bSuiv.hidden && bAjout.hidden);
      form.dataset.pas = pas;
      bSuiv.textContent = pas === PAS_FAMILLE ? 'Continuer, avec ou sans prénoms' : 'Continuer';
      if (pas === total) recap();
      if (pas !== PAS_COUV && actif !== 1 && !avecSecond) montrerLivre(1);
      if (sceneCre) {
        var livreOuvert = pas === PAS_DEDICACE;
        if (livreOuvert && !sceneCre.classList.contains('is-ouvert')) setTimeout(function () { majDedicace(true); }, reduit() ? 0 : 900);
        sceneCre.classList.toggle('is-ouvert', livreOuvert);
      }
      /* jamais de défilement de la page : seul le panneau revient en haut */
      if (panneau) panneau.scrollTop = 0;
      var zone = PAS[pas - 1], h = $('h1, h2', zone);
      if (focus !== false && h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    }
    /* un choix touché suffit : on passe à l'étape suivante, le temps de voir la case se cocher */
    form.addEventListener('click', function (ev) {
      if (ev.target.name !== 'pour' || pas !== 1) return;
      setTimeout(function () { if (pas === 1) aller(2); }, reduit() ? 0 : 280);
    });
    bSuiv.addEventListener('click', function () {
      var c = CONTROLES[pas];
      if (c) { var v = verifier(c); if (!v.ok) { if (v.premier) v.premier.focus(); return; } }
      aller(pas + 1);
    });
    bPrec.addEventListener('click', function () { aller(pas - 1); });
    form.addEventListener('click', function (ev) { var b = ev.target.closest('[data-aller]'); if (b) aller(Number(b.dataset.aller)); });
    form.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' && ev.target.tagName === 'INPUT' && ev.target.type !== 'checkbox' && pas < total) { ev.preventDefault(); bSuiv.click(); }
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      message('');
      var v1 = valider(1), v2 = avecSecond ? valider(2) : { ok: true };
      if (!v1.ok || !v2.ok) {
        if (!v1.ok) {
          var p1 = v1.premier && v1.premier.closest('[data-pas]'); montrerLivre(1);
          if (p1) aller(Number(p1.dataset.pas)); if (v1.premier) v1.premier.focus();
        } else { montrerLivre(2); if (v2.premier) v2.premier.focus(); }
        message('Il manque quelque chose : regardez le message en rouge.', 'erreur');
        return;
      }
      bAjout.disabled = true; bAjout.setAttribute('aria-busy', 'true');
      message('Nous préparons son livre…');
      var lien = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var dejaUn = false;
      ajouterLivre(form.dataset.variant, 1, lien)
        .then(function () { dejaUn = true; if (avecSecond) return ajouterLivre(form.dataset.variantSecond, 2, lien); })
        .then(function () {
          var a = attributsOrigine();
          return a ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: a }) }).catch(function () {}) : null;
        })
        .then(function () {
          if (!aRemplacer.length) return null;
          var maj = {}; aRemplacer.forEach(function (k) { maj[k] = 0; });
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: maj }) }).catch(function () {});
        })
        .then(function () {
          if (!aRemplacer.length) mesurerAjout(prix1 + (avecSecond ? prix2 : 0), avecSecond ? 2 : 1);
          message('C\'est dans votre panier.', 'ok');
          majCompteur(avecSecond ? 2 : 1);
          var s = $('[data-sceau]');
          var partir = function () { location.href = form.dataset.panier || '/cart'; };
          if (s && !reduit()) { s.classList.add('is-pose'); setTimeout(partir, 1250); } else partir();
        })
        .catch(function (err) {
          bAjout.disabled = false; bAjout.removeAttribute('aria-busy');
          message(dejaUn
            ? 'Le premier livre est bien dans votre panier, mais le second n\'a pas pu être ajouté (' + err.message + '). Réessayez, ou écrivez-nous.'
            : 'Le livre n\'a pas pu être ajouté au panier (' + err.message + '). Réessayez dans un instant.', 'erreur');
        });
    });

    /* un livre préparé par un proche : le lien partagé remplit tout (sauf la photo, qui ne voyage pas) */
    (function () {
      var q = new URLSearchParams(location.search); if (!q.get('lv')) return;
      var poser = function (sel, v) { var el = $(sel); if (!el || v == null || v === '') return; if (el.type === 'radio') { el.checked = true; } else el.value = v; el.dispatchEvent(new Event('input', { bubbles: true })); };
      poser('input[name="pour"][value="' + (q.get('pour') || '') + '"]', 1);
      poser('#prenom-1', (q.get('p') || '').slice(0, 14));
      poser('input[name="couleur-1"][value="' + (q.get('c') || '') + '"]', 1);
      poser('input[name="genre-1"][value="' + (q.get('g') || '') + '"]', 1);
      poser('input[name="ne-1"][value="' + (q.get('n') || '') + '"]', 1);
      poser('#date-1', q.get('d')); poser('#mois-1', q.get('m'));
      poser('#offert', (q.get('o') || '').slice(0, 24));
      if (q.get('r')) { poser('#remise-1', q.get('r')); }
      poser('#date-remise-1', q.get('dr'));
      poser('#dedicace-1', (q.get('de') || '').slice(0, 240));
      var aff = document.createElement('p'); aff.className = 'ln-message ln-message--ok';
      aff.textContent = 'Ce livre a été préparé pour vous. Relisez, ajoutez une photo si vous le souhaitez, puis commandez.';
      var pr = $('.cre__prog', form); pr.parentNode.insertBefore(aff, pr.nextSibling);
    })();
    var bPart = $('[data-partager]', form);
    if (bPart) bPart.addEventListener('click', function () {
      var e = etats[1], q = new URLSearchParams();
      q.set('lv', '1'); if (commun.pour) q.set('pour', commun.pour);
      [['p', e.prenom.trim()], ['c', e.couleur], ['g', e.genre], ['n', e.ne], ['d', e.date], ['m', e.mois], ['o', commun.offert.trim()], ['r', e.remise], ['dr', e.dateRemise], ['de', e.dedicace.trim()]].forEach(function (x) { if (x[1]) q.set(x[0], x[1]); });
      var url = location.origin + location.pathname + '?' + q.toString();
      var prenom = e.prenom.trim() || 'notre petit';
      var texte = 'J\u2019ai préparé le livre de naissance de ' + prenom + '. Tout est prêt : tu n\u2019as plus qu\u2019à le commander.';
      var msg = $('[data-partage-msg]', form), champ = $('[data-partage-lien]', form);
      var afficher = function (t) { msg.textContent = t; msg.hidden = false; };
      if (navigator.share) {
        navigator.share({ title: 'Le livre de ' + prenom, text: texte, url: url }).then(function () { afficher('C\u2019est envoyé.'); }).catch(function () {});
        return;
      }
      champ.value = url; champ.hidden = false; champ.select();
      if (navigator.clipboard) navigator.clipboard.writeText(texte + ' ' + url).then(function () { afficher('Le lien est copié : collez-le dans un SMS, WhatsApp ou un e-mail.'); }, function () { afficher('Copiez ce lien et envoyez-le par SMS, WhatsApp ou e-mail.'); });
      else afficher('Copiez ce lien et envoyez-le par SMS, WhatsApp ou e-mail.');
    });
    /* Modifier un livre depuis le panier : ?remplace=<clé de la ligne>. On relit la ligne (et son 2e livre lié) dans le panier,
       on remplit chaque étape, photos comprises (déjà envoyées, elles ne repartent pas), et on ouvre le récapitulatif. */
    var aRemplacer = [];
    (function () {
      var cle = new URLSearchParams(location.search).get('remplace'); if (!cle) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (rep) { return rep.json(); }).then(function (c) {
        var it = c.items.filter(function (x) { return x.key === cle; })[0]; if (!it) return;
        var P = it.properties || {}, lien = P._lien;
        var it2 = lien ? c.items.filter(function (x) { return x.key !== cle && (x.properties || {})._lien === lien; })[0] : null;
        aRemplacer = [it.key].concat(it2 ? [it2.key] : []);
        var poser = function (sel, v) { var el = $(sel); if (!el || v == null || v === '') return; if (el.type === 'radio' || el.type === 'checkbox') el.checked = true; else el.value = v; el.dispatchEvent(new Event('input', { bubbles: true })); if (el.tagName === 'SELECT' || el.type === 'checkbox') el.dispatchEvent(new Event('change', { bubbles: true })); };
        var isoJour = function (t) { var m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(t || ''); return m ? m[3] + '-' + m[2] + '-' + m[1] : ''; };
        var isoMois = function (t) { var m = /^(\S+) (\d{4})$/.exec((t || '').trim()); var k = m ? MOIS.indexOf(m[1]) : -1; return k >= 0 ? m[2] + '-' + (k < 9 ? '0' : '') + (k + 1) : ''; };
        var genre = function (t) { return /^Fille/.test(t || '') ? 'fille' : /^Garçon/.test(t || '') ? 'garcon' : 'surprise'; };
        var remplir = function (n, Q) {
          poser('#prenom-' + n, Q['Prénom']);
          poser('input[name="genre-' + n + '"][value="' + genre(Q['Fille ou garçon']) + '"]', 1);
          if (Q['Date de naissance']) { poser('input[name="ne-' + n + '"][value="oui"]', 1); poser('#date-' + n, isoJour(Q['Date de naissance'])); }
          else if (Q['Naissance prévue']) { poser('input[name="ne-' + n + '"][value="non"]', 1); poser('#mois-' + n, isoMois(Q['Naissance prévue'])); }
          var rm = /^Le (\d{2}\/\d{2}\/\d{4})/.exec(Q['Remise'] || ''), ra = /^(\d+) ans/.exec(Q['Remise'] || '');
          if (rm) { poser('#remise-' + n, 'autre'); poser('#date-remise-' + n, isoJour(rm[1])); } else if (ra) poser('#remise-' + n, ra[1]);
          poser('#dedicace-' + n, Q['Dédicace']);
        };
        var achete = P['Acheté par'], pour = Object.keys(POUR).filter(function (k) { return POUR[k].achete === achete; })[0];
        if (pour) { var rp = $('input[name="pour"][value="' + pour + '"]'); if (rp) { rp.checked = true; rp.dispatchEvent(new Event('input', { bubbles: true })); } }
        remplir(1, P);
        poser('#offert', P['Offert par']);
        try { JSON.parse(P._famille || '[]').forEach(function (m, k) { poser('[data-m="' + k + '"][data-k="nom"]', m.nom); poser('[data-m="' + k + '"][data-k="lien"]', m.lien); }); } catch (e) {}
        for (var k = 1; k <= 12; k++) {
          var u = P['Photo famille ' + k]; if (!u) continue;
          var v = commun.visages[k - 1], cad = {}; try { cad = JSON.parse(P['_cadrage ' + k] || '{}'); } catch (e) {}
          var et = (P['Visage ' + k] || '').replace('(sans légende)', '').trim(), q = QUI.filter(function (x) { return et === x || et.indexOf(x + ' ') === 0; }).sort(function (a, b) { return b.length - a.length; })[0] || '';
          v.url = u; v.distante = u; v.fichier = null; v.x = cad.x == null ? 50 : cad.x; v.y = cad.y == null ? 38 : cad.y; v.zoom = cad.zoom || 1;
          v.qui = q; v.prenom = q ? et.slice(q.length).trim() : et; v.etiquette = etiquette(v);
        }
        if (it2) { var cs = $('#second'); if (cs && !cs.checked) { cs.checked = true; cs.dispatchEvent(new Event('change', { bubbles: true })); } remplir(2, it2.properties || {}); }
        montrer(); tout(); prix(); majOnglets(); majDedicace(false); if (it2) montrerLivre(1);
        var aff = document.createElement('p'); aff.className = 'ln-message ln-message--ok';
        aff.textContent = 'Vous modifiez le livre de ' + (P['Prénom'] || 'votre enfant') + '. Touchez « Modifier » sur la ligne à changer : le nouveau livre remplacera l\u2019ancien dans votre panier.';
        var pr = $('.cre__prog', form); pr.parentNode.insertBefore(aff, pr.nextSibling);
        bAjout.firstChild.textContent = 'Mettre à jour le panier ';
        aller(total, false);
      }).catch(function () {});
    })();
    /* le prénom déjà tapé ailleurs (dernier mot, lien ?prenom=) */
    var champP = $('#prenom-1');
    if (prenomVisiteur && champP && !champP.value) { champP.value = prenomVisiteur; etats[1].prenom = prenomVisiteur; compte('c-prenom-1', prenomVisiteur, 14); }
    prix(); majOnglets(); tout(); majDedicace(false); aller(1, false);
  }

  /* ================= 6. le mouvement : ouverture, récit, feuilletage, voix ================= */
  function reduit() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* sans les bibliothèques de mouvement (réseau, bloqueur) : on retire la couche animée, tout est déjà ouvert et écrit */
  var AVEC_ANIM = !!(window.gsap && window.ScrollTrigger) && !reduit();
  if (!AVEC_ANIM) document.documentElement.classList.remove('ln-anim');

  /* le livre suit légèrement le pointeur (ou l'inclinaison du téléphone), avec un reflet sur le pelliculage */
  if (!reduit()) {
    $$('[data-incl]').forEach(function (inc) {
      var zone = inc.parentElement, livre = $('.livre', inc);
      var poser = function (nx, ny) {
        inc.style.setProperty('--py', (nx * 7).toFixed(2) + 'deg'); inc.style.setProperty('--px', (-ny * 5).toFixed(2) + 'deg');
        livre.style.setProperty('--gx', (30 + nx * 35).toFixed(1) + '%'); livre.style.setProperty('--gy', (20 + ny * 30).toFixed(1) + '%');
      };
      if (window.matchMedia('(hover: hover)').matches) {
        zone.addEventListener('pointermove', function (ev) {
          var r = zone.getBoundingClientRect(); poser((ev.clientX - r.left) / r.width * 2 - 1, (ev.clientY - r.top) / r.height * 2 - 1);
        });
        zone.addEventListener('pointerleave', function () { poser(0, 0); });
      }
    });
    if (window.DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission !== 'function' && !window.matchMedia('(hover: hover)').matches) {
      var inclins = $$('[data-incl]');
      window.addEventListener('deviceorientation', function (ev) {
        if (ev.gamma == null) return;
        var nx = Math.max(-1, Math.min(1, ev.gamma / 30)), ny = Math.max(-1, Math.min(1, (ev.beta - 45) / 30));
        inclins.forEach(function (inc) { inc.style.setProperty('--py', (nx * 5).toFixed(2) + 'deg'); inc.style.setProperty('--px', (-ny * 3).toFixed(2) + 'deg'); var l = $('.livre', inc); l.style.setProperty('--gx', (30 + nx * 35) + '%'); });
      }, { passive: true });
    }
  }

  /* les annotations manuscrites : tracées par ln-anim.js (Vara) ; sans lui, elles sont simplement visibles */
  $$('[data-annot]').forEach(function (a) { a.classList.add('is-trace'); });

  /* le chemin du livre : la frise pilote la page ouverte dans le livre */
  $$('[data-chemin]').forEach(function (ch) {
    var arrets = $$('[data-arret]', ch), pages = $$('.chemin__scene [data-pg]', ch), phrase = $('[data-chemin-phrase]', ch), piste = $('[data-frise]', ch);
    var prec = $('[data-frise-prec]', ch), suiv = $('[data-frise-suiv]', ch), i = 0;
    var scene = $('.chemin__scene', ch), bloc = $('.livre__bloc', scene), finTour = null;
    var montrer = function (n) { pages.forEach(function (p) { p.classList.toggle('is-vue', Number(p.dataset.pg) === n); }); };
    /* la page tourne vraiment : en avant, la page lue part vers la gauche ; en arrière, la page voulue revient de la gauche */
    var tourner = function (de, a) {
      if (finTour) finTour();
      var pDe = pages.filter(function (p) { return Number(p.dataset.pg) === de; })[0], pA = pages.filter(function (p) { return Number(p.dataset.pg) === a; })[0];
      if (de === a || reduit() || !pDe || !pA || !bloc || !Element.prototype.animate) { montrer(a); return; }
      var avance = a > de, f = document.createElement('div');
      f.className = 'ch-feuille'; f.setAttribute('aria-hidden', 'true');
      f.innerHTML = '<div class="ch-feuille__face"><i class="ch-feuille__ombre"></i></div><div class="ch-feuille__dos"></div>';
      var copie = (avance ? pDe : pA).cloneNode(true); copie.classList.add('is-vue');
      f.firstChild.insertBefore(copie, f.firstChild.firstChild);
      scene.classList.add('is-tourne');
      if (avance) montrer(a);
      bloc.appendChild(f);
      var t = 1000, ease = 'cubic-bezier(.55,.06,.3,1)';
      var kf = [{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(-12deg) skewY(-1.4deg)', offset: .25 }, { transform: 'rotateY(-179deg)' }];
      var ko = [{ opacity: 0 }, { opacity: .5 }];
      if (!avance) { kf.reverse(); kf[1].offset = .75; ko.reverse(); }
      var an = f.animate(kf, { duration: t, easing: ease, fill: 'forwards' });
      var ao = $('.ch-feuille__ombre', f).animate(ko, { duration: t, easing: ease, fill: 'forwards' });
      finTour = function () { finTour = null; an.onfinish = null; an.cancel(); ao.cancel(); if (!avance) montrer(a); f.remove(); scene.classList.remove('is-tourne'); };
      an.onfinish = function () { if (finTour) finTour(); };
    };
    var activer = function (n, focus) {
      if (n < 0 || n >= arrets.length) return;
      var avant = i; i = n;
      arrets.forEach(function (a, k) { a.setAttribute('aria-pressed', String(k === n)); });
      tourner(avant, n);
      var a = arrets[n];
      phrase.classList.add('is-change');
      setTimeout(function () {
        phrase.className = 'chemin__phrase ' + a.dataset.main; phrase.style.setProperty('--c', a.style.getPropertyValue('--c'));
        $('span', phrase).textContent = a.dataset.phrase;
        requestAnimationFrame(function () { phrase.classList.remove('is-change'); });
      }, reduit() ? 0 : 200);
      prec.disabled = n === 0; suiv.disabled = n === arrets.length - 1;
      var lecArret = $('[data-lec]', ch); if (lecArret && window.LNlecteur) window.LNlecteur.changer(lecArret, a.dataset.voix || '', a.dataset.voixLib || '');
      ch.dispatchEvent(new CustomEvent('ln:arret', { detail: { i: n, arret: a, phrase: phrase } }));
      if (piste.scrollWidth > piste.clientWidth) piste.scrollTo({ left: a.offsetLeft - (piste.clientWidth - a.offsetWidth) / 2, behavior: reduit() ? 'auto' : 'smooth' });
      if (focus) a.focus();
    };
    arrets.forEach(function (a, k) { a.addEventListener('click', function () { activer(k); }); });
    prec.addEventListener('click', function () { activer(i - 1); });
    suiv.addEventListener('click', function () { activer(i + 1); });
    piste.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowRight') { ev.preventDefault(); activer(i + 1, true); }
      if (ev.key === 'ArrowLeft') { ev.preventDefault(); activer(i - 1, true); }
    });
    activer(0);
  });

  /* la liste : les questions s'écrivent une à une quand la page entre à l'écran */
  $$('[data-liste]').forEach(function (el) {
    if (!('IntersectionObserver' in window)) { el.classList.add('is-vue'); return; }
    var io = new IntersectionObserver(function (ents) { if (ents[0].isIntersecting) { el.classList.add('is-vue'); io.disconnect(); } }, { threshold: .3 });
    io.observe(el);
  });

  /* le dernier mot : dix-huit étoiles s'allument une à une, une par anniversaire */
  $$('[data-fin]').forEach(function (f) {
    var etoiles = $$('[data-etoiles] i', f), n = $('[data-etoiles-n]', f), pl = $('[data-etoiles-s]', f), fait = false;
    var allumer = function () {
      if (fait) return; fait = true;
      etoiles.forEach(function (e, k) {
        setTimeout(function () { e.classList.add('is-on'); n.textContent = k + 1; pl.hidden = k === 0; if (k === etoiles.length - 1 && !reduit()) f.classList.add('is-scintille'); }, reduit() ? 0 : 260 + k * 170);
      });
    };
    if ('IntersectionObserver' in window) {
      var ioE = new IntersectionObserver(function (ents) { if (ents[0].isIntersecting) { allumer(); ioE.disconnect(); } }, { threshold: 0.35 });
      ioE.observe(f);
    } else allumer();
  });

  /* le feuilletage des vraies pages */
  $$('[data-feuil]').forEach(function (f) {
    var donneesP; try { donneesP = JSON.parse($('[data-feuil-pages]', f).textContent); } catch (e) { return; }
    var g = $('[data-feuil-g] img', f), d = $('[data-feuil-d] img', f), feuille = $('[data-feuil-feuille]', f);
    var leg = $('[data-feuil-leg]', f), cpt = $('[data-feuil-compte]', f), prec = $('[data-feuil-prec]', f), suiv = $('[data-feuil-suiv]', f);
    var zoom = $('[data-zoom]'), i = 0, occupe = false;
    var cadre = $('[data-feuil-cadre]', f), livreF = $('.feuil__livre', f), traits = $('[data-feuil-traits]', f), sect = f.closest('.feuil');
    var notes = { ecrit: $('[data-note="ecrit"]', f), qr: $('[data-note="qr"]', f) };
    var NS = 'http://www.w3.org/2000/svg';
    /* les annotations visent un endroit réel de la double page affichée (repères « x,y » en fraction de page) */
    var repere = function (k, cle) { var p = donneesP[k]; if (!p || !p[cle]) return null; var t = String(p[cle]).split(',').map(Number); return t.length === 2 && !isNaN(t[0]) && !isNaN(t[1]) ? t : null; };
    var cacherNotes = function () { traits.innerHTML = ''; Object.keys(notes).forEach(function (c) { if (notes[c]) notes[c].classList.remove('is-vue'); }); };
    var annoter = function () {
      cacherNotes();
      if (!cadre || !double() || window.innerWidth < 1180) return;
      var rc = cadre.getBoundingClientRect(), rl = livreF.getBoundingClientRect();
      var L = rl.left - rc.left, T = rl.top - rc.top, W = rl.width, H = rl.height, pw = W / 2;
      var cotes = [{ k: i, x0: L, cote: 'g' }, { k: i + 1, x0: L + pw, cote: 'd' }];
      var choix = {};
      var prendre = function (cle, ordre) { for (var n = 0; n < ordre.length; n++) { var c = cotes[ordre[n]], t = repere(c.k, cle); if (t) return { cote: c.cote, x: c.x0 + t[0] * pw, y: T + t[1] * H }; } return null; };
      choix.qr = prendre('qr', [0, 1]);
      choix.ecrit = prendre('ecrit', choix.qr && choix.qr.cote === 'g' ? [1, 0] : [0, 1]);
      Object.keys(choix).forEach(function (cle, n) {
        var c = choix[cle], el = notes[cle]; if (!c || !el) return;
        var lw = el.offsetWidth, lh = el.offsetHeight;
        var lx = c.cote === 'g' ? L - lw - 34 : L + W + 34;
        var ly = Math.max(T, Math.min(T + H - lh, c.y - lh / 2 - 28));
        el.style.left = lx + 'px'; el.style.top = ly + 'px';
        var sx = c.cote === 'g' ? lx + lw + 6 : lx - 6, sy = ly + lh * .55;
        var ex = c.x + (c.cote === 'g' ? -10 : 10), ey = c.y;
        var cx = (sx + ex) / 2, cy = Math.min(sy, ey) - 46;
        var dx = ex - cx, dy = ey - cy, a = Math.atan2(dy, dx), b = 0.5, lg = 13;
        var tete = 'M' + (ex - lg * Math.cos(a - b)).toFixed(1) + ' ' + (ey - lg * Math.sin(a - b)).toFixed(1) + ' L' + ex.toFixed(1) + ' ' + ey.toFixed(1) + ' L' + (ex - lg * Math.cos(a + b)).toFixed(1) + ' ' + (ey - lg * Math.sin(a + b)).toFixed(1);
        var g = document.createElementNS(NS, 'g'); g.setAttribute('class', 'feuil__trait feuil__trait--' + cle);
        [['M' + sx.toFixed(1) + ' ' + sy.toFixed(1) + ' Q' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ' ' + ex.toFixed(1) + ' ' + ey.toFixed(1), 0], [tete, 1]].forEach(function (d) {
          var pth = document.createElementNS(NS, 'path'); pth.setAttribute('d', d[0]); pth.setAttribute('pathLength', '1'); pth.style.transitionDelay = (n * .25 + d[1] * .45) + 's'; g.appendChild(pth);
        });
        var cible = document.createElementNS(NS, 'circle'); cible.setAttribute('cx', c.x.toFixed(1)); cible.setAttribute('cy', c.y.toFixed(1)); cible.setAttribute('r', '15'); g.appendChild(cible);
        traits.appendChild(g);
        requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add('is-trace'); el.classList.add('is-vue'); }); });
      });
    };
    /* la double page entière, titre et boutons compris, reste dans l'écran pendant qu'on tourne */
    var caler = function () {
      if (!sect) return;
      var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--haut')) || 72;
      var r = sect.getBoundingClientRect(), nav = $('.feuil__nav', f).getBoundingClientRect();
      if (r.top < hh - 4 || nav.bottom > window.innerHeight + 2) {
        /* la section entière si elle tient ; sinon (téléphone) le livre et ses boutons, juste sous l'en-tête */
        var cible = sect.offsetHeight <= window.innerHeight - hh + 4 ? r.top - hh : cadre.getBoundingClientRect().top - hh - 12;
        if (nav.bottom - cible <= window.innerHeight + 2) window.scrollTo({ top: window.scrollY + cible, behavior: reduit() ? 'auto' : 'smooth' });
      }
    };
    var double = function () { return window.innerWidth >= 700; };
    var pas_ = function () { return double() ? 2 : 1; };
    var poser = function (img, k) { var p = donneesP[k]; if (p) { img.src = p.src; img.alt = p.leg; img.parentNode.hidden = false; } else { img.removeAttribute('src'); img.alt = ''; } };
    var dessiner = function () {
      if (double()) { if (i % 2) i -= 1; poser(g, i); poser(d, i + 1); leg.textContent = donneesP[i].leg + (donneesP[i + 1] ? ' · ' + donneesP[i + 1].leg : ''); }
      else { poser(d, i); leg.textContent = donneesP[i].leg; }
      cpt.textContent = (double() ? (i + 1) + '-' + Math.min(i + 2, donneesP.length) : (i + 1)) + ' sur ' + donneesP.length;
      prec.disabled = i === 0; suiv.disabled = i + pas_() >= donneesP.length;
      annoter();
      [donneesP[i + pas_()], donneesP[i + pas_() + 1]].forEach(function (p) { if (p) { var im = new Image(); im.src = p.src; } });
    };
    var tourner = function (sens) {
      if (occupe) return;
      var n = i + sens * pas_(); if (n < 0 || n >= donneesP.length) return;
      caler(); cacherNotes();
      if (reduit() || sens < 0) { i = n; dessiner(); return; }
      if (window.LNA && window.LNA.tourner) {
        occupe = true;
        var faceS = double() ? donneesP[i + 1].src : donneesP[i].src, dosS = double() ? (donneesP[n] ? donneesP[n].src : '') : '';
        if (double()) poser(d, n + 1); else poser(d, n);
        window.LNA.tourner(feuille, faceS, dosS, function () { i = n; dessiner(); occupe = false; });
        return;
      }
      occupe = true;
      var face = $('.face img', feuille), dos = $('.dos img', feuille);
      if (double()) { face.src = donneesP[i + 1].src; dos.src = donneesP[n] ? donneesP[n].src : ''; poser(d, n + 1); }
      else { face.src = donneesP[i].src; dos.src = ''; poser(d, n); }
      feuille.style.transition = 'none'; feuille.style.transform = 'rotateY(0deg)'; feuille.hidden = false;
      void feuille.offsetWidth;
      feuille.style.transition = ''; feuille.style.transform = 'rotateY(-180deg)';
      setTimeout(function () { i = n; dessiner(); feuille.hidden = true; occupe = false; }, 900);
    };
    prec.addEventListener('click', function () { tourner(-1); });
    suiv.addEventListener('click', function () { tourner(1); });
    f.addEventListener('keydown', function (ev) { if (ev.key === 'ArrowRight') tourner(1); if (ev.key === 'ArrowLeft') tourner(-1); });
    var x0 = null;
    f.addEventListener('touchstart', function (ev) { x0 = ev.touches[0].clientX; }, { passive: true });
    f.addEventListener('touchend', function (ev) { if (x0 === null) return; var dx = ev.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) tourner(dx < 0 ? 1 : -1); x0 = null; });
    $$('.feuil__p', f).forEach(function (b) {
      b.addEventListener('click', function () {
        var im = $('img', b); if (!zoom || !im.src) return;
        $('img', zoom).src = im.src; $('img', zoom).alt = im.alt;
        if (zoom.showModal) zoom.showModal(); else zoom.setAttribute('open', '');
      });
    });
    if (zoom) {
      $('[data-zoom-fermer]', zoom).addEventListener('click', function () { zoom.close ? zoom.close() : zoom.removeAttribute('open'); });
      zoom.addEventListener('click', function (ev) { if (ev.target === zoom) zoom.close(); });
    }
    var dernierDouble = double();
    var minuteRe = null;
    window.addEventListener('resize', function () { if (double() !== dernierDouble) { dernierDouble = double(); dessiner(); } else { clearTimeout(minuteRe); minuteRe = setTimeout(annoter, 150); } });
    if ('IntersectionObserver' in window) { var ioF = new IntersectionObserver(function (ents) { if (ents[0].isIntersecting) { annoter(); ioF.disconnect(); } }, { threshold: .5 }); ioF.observe(livreF); }
    $$('img', livreF).forEach(function (im) { im.addEventListener('load', function () { if (!occupe) annoter(); }); });
    dessiner();
  });

  /* la voix : un vrai son seulement s'il existe ; sinon on le dit */
  $$('[data-lecteur]').forEach(function (l) {
    var btn = $('[data-lecteur-btn]', l), note = $('[data-lecteur-note]', l), audio = null, minuterie = null;
    var etat = function (on) {
      l.classList.toggle('is-joue', on);
      $('[data-ic-play]', btn).hidden = on; $('[data-ic-pause]', btn).hidden = !on;
      btn.setAttribute('aria-label', on ? 'Mettre en pause' : 'Écouter l\'exemple de Mamie Christine');
    };
    btn.addEventListener('click', function () {
      if (l.dataset.audio) {
        if (!audio) { audio = new Audio(l.dataset.audio); audio.addEventListener('ended', function () { etat(false); }); }
        if (audio.paused) { audio.play(); etat(true); } else { audio.pause(); etat(false); }
        return;
      }
      if (l.classList.contains('is-joue')) { clearTimeout(minuterie); etat(false); return; }
      etat(true); note.style.color = 'var(--encre)';
      minuterie = setTimeout(function () { etat(false); }, 3600);
    });
  });

  /* en-tête : fond au défilement ; menu sur téléphone */
  var haut = $('#l-haut');
  if (haut) {
    /* hauteur exacte de l'en-tête : l'atelier de création remplit l'écran au pixel près, sans défilement */
    var majH = function () { document.documentElement.style.setProperty('--haut', haut.offsetHeight + 'px'); };
    majH(); window.addEventListener('resize', majH, { passive: true });
    var seuil = haut.classList.contains('l-haut--ciel') ? Math.max(200, ($('.ouv') || { offsetHeight: 600 }).offsetHeight - 90) : 8;
    var majHaut = function () { haut.classList.toggle('is-defile', window.scrollY > seuil); };
    window.addEventListener('scroll', majHaut, { passive: true }); majHaut();
  }
  var tiroir = $('#l-tiroir'), ouvrir = $('[data-menu-ouvrir]');
  if (tiroir && ouvrir) {
    var fermer = function () { tiroir.classList.remove('is-ouvert'); ouvrir.setAttribute('aria-expanded', 'false'); setTimeout(function () { tiroir.hidden = true; }, 300); document.documentElement.style.overflow = ''; ouvrir.focus(); };
    ouvrir.addEventListener('click', function () {
      tiroir.hidden = false; requestAnimationFrame(function () { tiroir.classList.add('is-ouvert'); });
      ouvrir.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden';
      var b = $('[data-menu-fermer]', tiroir); if (b) b.focus();
    });
    $('[data-menu-fermer]', tiroir).addEventListener('click', fermer);
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !tiroir.hidden) fermer(); });
  }

  /* ================= 7. les lecteurs de voix ================= */
  (function () {
    var blocs = $$('[data-lec]'); if (!blocs.length) return;
    var ST = {}; try { ST = JSON.parse(($('#ln-sous-titres') || {}).textContent || '{}'); } catch (e) {}
    var COULEURS = ['#c4543c', '#e3a12f', '#2e7d62', '#3e78b5', '#e06a93'];
    var ctx = null, actuel = null;
    function source(bloc) { return bloc.dataset.base + 'ln-voix-' + bloc.dataset.voix + '.mp3' + (bloc.dataset.baseFin || ''); }
    function dispo(bloc, v) { return (',' + (bloc.dataset.dispo || '') + ',').indexOf(',' + v + ',') >= 0; }
    function soustitre(bloc) {
      var st = $('[data-lec-st]', bloc), d = ST[bloc.dataset.voix]; if (!st) return;
      st.innerHTML = '';
      if (!d) return;
      d.cues.forEach(function (c, k) {
        var fin = k + 1 < d.cues.length ? d.cues[k + 1][0] : d.duree;
        c[1].split(' ').forEach(function (m, j, t) {
          var sp = document.createElement('span'); sp.textContent = m + ' ';
          sp.dataset.t = (c[0] + (fin - c[0]) * (j / t.length)).toFixed(2); st.appendChild(sp);
        });
      });
    }
    function arreter(bloc) {
      if (!bloc || !bloc._audio) return;
      bloc._audio.pause(); etat(bloc, false);
    }
    function etat(bloc, on) {
      bloc.classList.toggle('is-joue', on);
      var btn = $('[data-lec-btn]', bloc);
      $('[data-lec-play]', btn).hidden = on; $('[data-lec-pause]', btn).hidden = !on;
      btn.setAttribute('aria-pressed', String(on));
      if (!on) $$('.lec__onde i', bloc).forEach(function (b) { b.style.removeProperty('--h'); });
    }
    function boucle(bloc) {
      var barres = $$('.lec__onde i', bloc), donnees = bloc._an ? new Uint8Array(bloc._an.frequencyBinCount) : null;
      var mots = $$('[data-lec-st] span', bloc);
      (function f() {
        if (!bloc.classList.contains('is-joue')) return;
        if (bloc._an) {
          bloc._an.getByteFrequencyData(donnees);
          var n = barres.length, mi = (n - 1) / 2; barres.forEach(function (b, k) { /* onde en miroir : les graves au centre, les aigus vers les bords (bandes de la voix seulement) */ var v = donnees[1 + Math.round(Math.abs(k - mi) / mi * 11)] / 255; b.style.setProperty('--h', (3 + v * 17).toFixed(1) + 'px'); });
        } else {
          var t = performance.now() / 160; barres.forEach(function (b, k) { b.style.setProperty('--h', (5 + 7 * Math.abs(Math.sin(t + k * .7))).toFixed(1) + 'px'); });
        }
        var tc = bloc._audio.currentTime;
        mots.forEach(function (m) { m.classList.toggle('is-dit', Number(m.dataset.t) <= tc); });
        requestAnimationFrame(f);
      })();
    }
    function jouer(bloc) {
      if (actuel && actuel !== bloc) arreter(actuel);
      actuel = bloc;
      if (!bloc._audio) {
        var a = new Audio(); a.preload = 'auto'; a.crossOrigin = 'anonymous'; a.src = source(bloc);
        a.addEventListener('ended', function () { etat(bloc, false); $$('[data-lec-st] span', bloc).forEach(function (m) { m.classList.add('is-dit'); }); });
        a.addEventListener('error', function () { bloc.hidden = true; }); /* fichier absent : on retire le lecteur, jamais de bouton mort */
        bloc._audio = a;
        try {
          ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
          var srcN = ctx.createMediaElementSource(a), an = ctx.createAnalyser(); an.fftSize = 64; an.smoothingTimeConstant = .7;
          srcN.connect(an); an.connect(ctx.destination); bloc._an = an;
        } catch (e) { bloc._an = null; }
      }
      if (ctx && ctx.state === 'suspended') ctx.resume();
      soustitre(bloc);
      var pr = bloc._audio.play(); if (pr && pr.catch) pr.catch(function () { etat(bloc, false); });
      etat(bloc, true); boucle(bloc);
    }
    blocs.forEach(function (bloc) {
      $$('.lec__onde i', bloc).forEach(function (b, k) { b.style.setProperty('--b', COULEURS[k % 5]); });
      $('[data-lec-btn]', bloc).addEventListener('click', function () {
        if (bloc.classList.contains('is-joue')) arreter(bloc); else jouer(bloc);
      });
    });
    window.LNlecteur = {
      changer: function (bloc, voix, lib) {
        arreter(bloc);
        if (!voix || !dispo(bloc, voix)) { bloc.hidden = true; return; }
        bloc.hidden = false;
        if (bloc.dataset.voix !== voix) {
          bloc.dataset.voix = voix; bloc.style.setProperty('--c', 'var(--' + voix + ')');
          if (bloc._audio) { bloc._audio.src = source(bloc); }
          var st = $('[data-lec-st]', bloc); if (st) st.innerHTML = '';
        }
        if (lib) { $('[data-lec-lib]', bloc).textContent = lib; $('[data-lec-btn]', bloc).setAttribute('aria-label', lib); }
      }
    };
  })();
})();

/* Téléphone (18/10/2026) : cartes à glisser (l'aide « Faites glisser » s'efface au premier geste)
   et barre d'achat collante (après l'ouverture, cachée près des autres boutons et tant que le bandeau cookies est là). */
(function () {
  document.querySelectorAll('[data-glisse]').forEach(function (g) {
    var aide = g.previousElementSibling;
    if (!aide || !aide.classList.contains('glisse-aide')) return;
    g.addEventListener('scroll', function () { if (g.scrollLeft > 12) aide.classList.add('is-vu'); }, { passive: true });
  });
  var barre = document.querySelector('[data-barre]');
  if (!barre || !('IntersectionObserver' in window)) return;
  var ouv = document.querySelector('.ouv3'), offre = document.getElementById('offre'), fin = document.querySelector('[data-fin]');
  var cookies = document.getElementById('ln-cookies');
  var vus = new Set();
  function maj() {
    var cookiesLa = cookies && !cookies.hidden && cookies.classList.contains('is-on');
    var montrer = !vus.size && !cookiesLa && window.scrollY > 200;
    barre.hidden = false;
    barre.classList.toggle('is-on', montrer);
    barre.setAttribute('aria-hidden', montrer ? 'false' : 'true');
    barre.querySelector('a').tabIndex = montrer ? 0 : -1;
  }
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (e) { if (e.isIntersecting) vus.add(e.target); else vus.delete(e.target); });
    maj();
  }, { threshold: 0 });
  [ouv, offre, fin].forEach(function (x) { if (x) io.observe(x); });
  if (cookies && 'MutationObserver' in window) new MutationObserver(maj).observe(cookies, { attributes: true, attributeFilter: ['hidden', 'class'] });
  addEventListener('scroll', maj, { passive: true });
  maj();
})();
